import { Card, Col, Divider, List, Row, Typography } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import ProfileDetectionThreshold from 'components/profile/profileDetectionThreshold';
import React from 'react';
import classes from './style.module.scss';

const { Title, Paragraph, Text } = Typography;

const DetectionThreshold = () => {
  const { md } = useBreakpoint();
  return (
    <>
      <div className={classes.content} style={{ padding: md ? 16 : 0 }}>
        <Row>
          <Col md={12} xs={24} style={{ paddingRight: md ? 8 : 0 }}>
            <ProfileDetectionThreshold />
          </Col>
          <Col md={12} xs={24} style={{ paddingLeft: md ? 8 : 0 }}>
            <Card title="Detection Threshold Settings" className={classes.profileCard}>
              <Typography>
                <Paragraph>
                  Customize how your images and videos are analyzed by the system. These settings are specific to your account and can be changed anytime. Updates only affect <Text strong>new</Text> images/videos — anything already processed won’t change.
                </Paragraph>

                <Divider />

                <Title level={5}>Category Priority</Title>
                <Paragraph>
                  You can rearrange the categories to set their priority.
                </Paragraph>
                <Paragraph>
                  For example:<br />
                  If <Text strong>Deer</Text> is at the top of the list and an image has both a deer and a hog, it will be labeled as a <Text strong>Deer</Text> image.
                </Paragraph>
                <Paragraph>
                  Don’t have certain animals on your property? Just uncheck the box to turn that category off completely.
                </Paragraph>
                <Divider />
                <Title level={5}>Sensitivity Sliders</Title>
                <Paragraph>
                  Each category has a slider that lets you control how sensitive the detector is:
                </Paragraph>
                <List
                  size="small"
                  split={false}
                  style={{ paddingLeft: 20, overflow: 'hidden' }}
                  dataSource={[
                    <><Text strong>Middle position</Text> = Default sensitivity</>,
                    <><Text strong>Slide to the right</Text> = Stricter detection (fewer images classified in that category)</>,
                    <><Text strong>Slide to the left</Text> = Looser detection (more images classified in that category)</>,
                  ]}
                  renderItem={(item) => <List.Item style={{ display: 'list-item', listStyleType: 'disc' }}>{item}</List.Item>}
                />

                <Paragraph>
                  Adjust these to fine-tune what matters most to you. You can update them anytime.
                </Paragraph>
              </Typography>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DetectionThreshold;
